import { Flex, FooterLink } from "@sidelinesports/fan-design-system";
import { useQuery } from "@tanstack/react-query";
import { getAppConfig } from "../api";

export const AppFooter = () => {
  const configQuery = useQuery({
    queryKey: ["config"],
    queryFn: () => getAppConfig(),
  });

  if (configQuery.isPending) {
    return null;
  }

  if (configQuery.isError) {
    return null;
  }

  const config = configQuery.data;

  return (
    <Flex as="footer" gap="1rem" align="center" justify="center">
      {config.theme.footers.map((footer) => {
        return (
          <FooterLink as="a" key={footer.order} href={footer.hyperlink}>
            {footer.text}
          </FooterLink>
        );
      })}
    </Flex>
  );
};
